import { RouteComponentProps } from 'react-router';
import { type___geo___lngLat, type___map___element___type, type___map___filters } from '../../types/types.types'
import { type___iframe___configParams, type___configParams___standards } from '../../types/types.iframe';

//	P R O P S

export interface props___SbDiscoverMapPage extends RouteComponentProps<{ id: string; }> {

}

//	S T A T E

export interface state___SbDiscoverMapPage {

	map___isCentered: boolean,
	map___isLoading: boolean,

	map_area___zoom: number,

	map___filters: type___map___filters,

	map___element_pane: 'element' | 'navigation',
	map___element_pane___content_type: type___map___element___type,
	map___element_pane___content_id: string | null,
	map___element_pane___content_props: any | null,

}

//	S T A T E   D E F A U L T

export const state___SbDiscoverMapPage___defaults: state___SbDiscoverMapPage = {

	map___isCentered: false,
	map___isLoading: false,

	map_area___zoom: 35,

	map___filters: { show_events: true, show_poi: true, show_tales: true, show_smartAi: false, config_iframe: type___configParams___standards },

	map___element_pane: 'navigation',
	map___element_pane___content_type: null,
	map___element_pane___content_id: null,
	map___element_pane___content_props: null,

}